import { z } from 'zod';
import { OppositionType } from '@academia-apolo/shared-types';
export const createProspectSchema = z.object({
    first_name: z.string().min(2, 'El nombre debe tener al menos 2 caracteres').max(100),
    last_name: z.string().min(2, 'Los apellidos deben tener al menos 2 caracteres').max(100),
    email: z.string().email('Email inválido'),
    phone: z
        .string()
        .regex(/^[6789]\d{8}$/, 'Teléfono inválido'),
    opposition_interest: z.nativeEnum(OppositionType).optional(),
    message: z.string().max(500, 'El mensaje no puede superar 500 caracteres').optional(),
    privacy_consent: z.literal(true, {
        errorMap: () => ({ message: 'Debes aceptar la política de privacidad' }),
    }),
});
// `enrolled` is intentionally excluded: enrolling is only valid via the conversion
// flow (POST /students/from-prospect/:id), which creates the auth user, profile,
// student record, initial payment and welcome email. Allowing it here would leave
// an "enrolled" prospect with no student and permanently block the real conversion.
// (El antiguo campo opcional `notes` era fantasma: nada lo enviaba ni se
// persistía. Las anotaciones de prospects viven ahora en prospect_notes.)
export const updateProspectStatusSchema = z.object({
    status: z.enum(['new', 'contacted', 'discarded']),
});
//# sourceMappingURL=prospect.schema.js.map